import React from "react";
import { useParams } from "react-router-dom";
import { SettingsOutlined } from "@material-ui/icons";
import { Button } from "@my-scoot/component-library-legacy";
import { app_route_keys } from "constants/urlPaths";
import withComponentLibraryTheme from "hocs/withComponentLibraryTheme";
import { navigateTo } from "utils/urlUtils";

export const ManageVariationsButton = withComponentLibraryTheme(
  ({ offeringType }) => {
    const { listing_uuid: offeringUuid } = useParams();

    return (
      <div className="">
        <Button
          color="secondary"
          variant="outlined"
          size="small"
          className="!tw-h-[32px] !tw-text-[14px]"
          onClick={() =>
            navigateTo(app_route_keys.offering_variations, {
              args: { offeringUuid: offeringUuid, offeringType: offeringType },
            })
          }
        >
          <SettingsOutlined className="!tw-h-[18px] !tw-w-[18px] tw-mr-[6px]" />
          Manage variations
        </Button>
      </div>
    );
  }
);
